import { z } from 'zod';

export const TABLET_COLLECTION = 'tablets';

export const DEFAULT_SINGLE_EVENT_KEY = '1';

export const TabletSchema = z.object({
  id: z.string().optional(),
  name: z.string().nonempty('Name is required').default(''),
  // Lowercased name; the public suite XML endpoint looks tablets up by this
  // field, so it is maintained by the write helpers, never edited directly.
  nameLower: z.string().optional(),
  location: z.string().nonempty('Location is required').default(''),
  // A tablet belongs to at most one group; null = ungrouped (reports OFF).
  groupId: z.string().nullable().default(null),
  // Vision Edge suite ID. Part of the QR payload; null until backfilled.
  suiteId: z.number().int().nullable().default(null),
  // Per-tablet key, part of the QR payload (default "1").
  singleEventKey: z.string().default(DEFAULT_SINGLE_EVENT_KEY),
  // Informational only; kept as text so leading zeros survive ("00121").
  pin: z.string().nullable().default(null),
  // "QR control": whether this tablet gets a QR code at all (clubs/lounges
  // typically don't). Docs written before the field existed count as enabled.
  qrEnabled: z.boolean().default(true),
});

export type Tablet = z.infer<typeof TabletSchema>;

/**
 * The string the tablet QR code is derived from: `suiteId_singleKey_eventKey`.
 * Returns null when the tablet has no suite ID yet.
 */
export function tabletQrSource(
  tablet: Pick<Tablet, 'suiteId' | 'singleEventKey'>,
  eventKey: string
): string | null {
  if (tablet.suiteId === null || tablet.suiteId === undefined) return null;
  const singleKey = tablet.singleEventKey || DEFAULT_SINGLE_EVENT_KEY;
  return `${tablet.suiteId}_${singleKey}_${eventKey}`;
}
